<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.71 21.1">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Layer_2-2" data-name="Layer 2">
          <g id="Layer_1-2-2" data-name="Layer 1-2">
            <line
              fill="none"
              :stroke="color"
              stroke-width="2"
              x1="6.75"
              y1="16.59"
              x2="0.71"
              y2="10.55"
            />
            <line
              fill="none"
              :stroke="color"
              stroke-width="2"
              x1="0.71"
              y1="10.55"
              x2="6.75"
              y2="4.51"
            />
            <line
              fill="none"
              :stroke="color"
              stroke-width="2"
              x1="20.97"
              y1="4.51"
              x2="27.01"
              y2="10.55"
            />
            <line
              fill="none"
              :stroke="color"
              stroke-width="2"
              x1="27.01"
              y1="10.55"
              x2="20.97"
              y2="16.59"
            />
            <line
              fill="none"
              :stroke="color"
              stroke-width="2"
              x1="8.63"
              y1="20.42"
              x2="19.45"
              y2="0.68"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'CodeIcon',
    props: {
      color: {
        type: String,
        default: '#000000',
      },
    },
  }
</script>

<style scoped>
  svg {
    width: 27.71px;
    height: 21.1px;
  }
</style>
